import React from "react";
import Modal from "react-modal";

interface Props {
  closeModal: () => void;
}

Modal.setAppElement("body");

export const InterviewSettingHelpModal = ({
  closeModal,
}: Props): JSX.Element => {
  const customStyles = {
    overlay: {
      zIndex: 9999,
      backgroundColor: "rgba(9, 32, 36, 0.9)",
    },
    content: {
      background: "none",
      border: "none",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      padding: "0",
    },
  };

  return (
    <Modal isOpen={true} style={customStyles}>
      <div className='animated fadeIn fixed inset-0 overflow-y-auto flex items-center justify-center'>
        <div className='max-h-screen w-full max-w-lg relative'>
          <div className='bg-legacyColor-secondary-50 rounded-3xl border border-legacyColor-neutral-2-500 p-4 '>
            <div className='p-6'>
              <ul className='list-disc list-inside'>
                <li>Click on calendar to create your available slots.</li>
                <li>Click on an existing slot to delete it.</li>
                <li>Drag the mouse over a slot to adjust it.</li>
                <li>
                  The yellow area represents the proposed slot from candidate,
                  click on it to confirm.
                </li>
                <li>
                  If you need to make changes after confirming, please contact
                  Talent representative.
                </li>
              </ul>
            </div>
            <div className='text-center w-full pt-2'>
              <button className='btn btn-sm btn-primary' onClick={closeModal}>
                Got it
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
